import { RouteParam } from "../../../routes";
import { MODULE, ACTION } from "../../../utils/enums";
import { urls } from "../../../utils/urls";
import ProjectCreateScreen from "../project/project_master/project_create_screen";
import ProjectListScreen from "../project/project_master/project_list_screen";

const project_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.project_master,
    component: ProjectListScreen,
    module: MODULE.master_data_panel,
    main_module: MODULE.project_master,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },

  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.project_master + "/create",
    component: ProjectCreateScreen,
    module: MODULE.procurement_master,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.project_master + "/update/:id",
    component: ProjectCreateScreen,
    module: MODULE.procurement_master,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  // {
  //   isPrivate: true,
  //   fullScreen: false,
  //   exact: true,
  //   path: urls.procurement_project + "/update/:id",
  //   component: ProjectApprovalScreen,
  //   module: MODULE.purchase_order,
  //   main_module: MODULE.procurement_panel,
  //   action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
  //   operator: "or",
  // },
];

export default project_routes;
